<!-- Desktop view -->
<a [routerLink]="['/konto/dokumenty', getDocumentId(), 'podglad']"
   class="document-row grid items-center gap-2 sm:gap-3 lg:gap-4 px-3 sm:px-4 py-2 sm:py-3 bg-white dark:bg-[#0d121e] hover:bg-gray-50 dark:hover:bg-gray-800/50 transition-colors cursor-pointer"
   [class.documents-grid]="!isDraftsView"
   [class.documents-grid-drafts]="isDraftsView"
   [class.menu-active]="isMenuOpen">
  
  <!-- Dokument (icon + nazwa) -->
  <div class="flex items-center gap-2 sm:gap-3 min-w-0">
    <div class="flex-shrink-0 w-8 h-8 sm:w-9 sm:h-9 rounded-lg flex items-center justify-center"
         [ngClass]="getDirectionBadge().bgClass"
         [matTooltip]="getDirectionBadge().text">
      <mat-icon 
        class="icon-size-5"
        [ngClass]="getDirectionBadge().iconClass"
        [svgIcon]="getDirectionBadge().icon">
      </mat-icon>
    </div>
    
    <div class="min-w-0">
      <div class="flex items-center gap-2">
        <span class="font-medium truncate">{{ getDocumentName() }}</span>
        <!-- Ikona KSeF dla dokumentów z KSeF -->
        <div 
          *ngIf="document.source === 'ksef'"
          class="flex-shrink-0 px-1.5 rounded bg-blue-50 dark:bg-gray-800 flex items-center justify-center"
          matTooltip="Faktura pochodzi z KSeF - nie została wygenerowana w tym programie">
          <mat-icon 
            class="!w-3.5 !h-3.5"
            [svgIcon]="'ksef:ksef-logo'">
          </mat-icon>
        </div>
        <!-- Badge dla lokalnych dokumentów -->
        <span 
          *ngIf="document.source !== 'ksef'"
          class="flex-shrink-0 px-1.5 py-0.5 text-[10px] rounded font-medium"
          [ngClass]="getSourceBadge().class">
          {{ getSourceBadge().text }}
        </span>
      </div>
      <div class="text-xs text-gray-500 truncate">{{ document.documentType | documentTypeName }}</div>
      
      <!-- Mobile sub-row: kwota + płatność + ksef (phone only) -->
      <div class="flex items-center gap-2 mt-0.5 sm:hidden">
        <span class="text-xs font-semibold text-gray-900 dark:text-gray-100">{{ getGrossAmount() | number:'1.2-2' }} {{ getCurrency() }}</span>
        <span 
          *ngIf="!isDraftsView"
          class="inline-flex items-center justify-center w-4 h-4 rounded-full"
          [ngClass]="getPaymentStatusInfo().bgClass">
          <mat-icon 
            class="!w-3 !h-3" 
            [ngClass]="getPaymentStatusInfo().colorClass"
            [svgIcon]="getPaymentStatusInfo().icon">
          </mat-icon>
        </span>
        <span 
          *ngIf="!isDraftsView && enableKsefFeatures"
          class="inline-flex items-center gap-0.5 text-[10px]"
          [ngClass]="getKsefStatusColor()">
          <mat-icon 
            class="!w-3 !h-3"
            [class.animate-spin]="getKsefStatus().status === 'sending'"
            [svgIcon]="getKsefStatusIcon()">
          </mat-icon>
          {{ getKsefStatus().status === 'synced' ? 'KSeF' : 
             getKsefStatus().status === 'sending' ? 'Wysyłanie...' : 
             getKsefStatus().status === 'pending' ? 'Oczekuje' :
             getKsefStatus().status === 'error' ? 'Błąd KSeF' :
             getKsefStatus().status === 'expired' ? 'Przeterminowana' :
             getKsefStatus().status === 'draft' ? 'Szkic' : '' }}
        </span>
      </div>
    </div>
  </div>
  
  <!-- Kontrahent -->
  <div class="min-w-0 hidden sm:block">
    <div class="text-sm truncate text-gray-700 dark:text-gray-300">
      {{ getContractorName() }}
    </div>
    <span 
      *ngIf="getContractorIdentifier()" 
      class="text-xs text-gray-400 hover:text-primary cursor-pointer transition-colors"
      (click)="onNipClick($event)"
      matTooltip="Kliknij, aby wyszukać dokumenty tego kontrahenta">
      {{ getContractorIdentifier()?.prefix }}: {{ getContractorIdentifier()?.value }}
    </span>
  </div>
  
  <!-- Data -->
  <div class="text-sm text-gray-500 hidden lg:block">
    <date-formatter [date]="getIssueDate()"></date-formatter>
  </div>
  
  <!-- Kwota (hidden on phone - shown in sub-row) -->
  <div class="text-right font-semibold whitespace-nowrap text-sm sm:text-base hidden sm:block">
    {{ getGrossAmount() | number:'1.2-2' }} {{ getCurrency() }}
  </div>
  
  <!-- Status płatności (hidden on phone - shown in sub-row) -->
  <div *ngIf="!isDraftsView" class="text-center hidden sm:block">
    <span 
      class="inline-flex items-center justify-center w-6 h-6 rounded-full"
      [ngClass]="getPaymentStatusInfo().bgClass"
      [matTooltip]="getPaymentStatusInfo().text">
      <mat-icon 
        class="icon-size-4" 
        [ngClass]="getPaymentStatusInfo().colorClass"
        [svgIcon]="getPaymentStatusInfo().icon">
      </mat-icon>
    </span>
  </div>
  
  <!-- Status KSeF (ukryte w widoku szkiców i gdy KSeF features wyłączone) -->
  <div *ngIf="!isDraftsView && enableKsefFeatures" class="text-center hidden sm:block">
    <mat-icon 
      class="icon-size-5"
      [ngClass]="getKsefStatusColor()"
      [class.animate-spin]="getKsefStatus().status === 'sending'"
      [svgIcon]="getKsefStatusIcon()"
      [matTooltip]="getKsefStatusTooltip()">
    </mat-icon>
  </div>
  
  <!-- Akcje -->
  <div class="flex justify-end">
    <button mat-icon-button [matMenuTriggerFor]="docMenu" (click)="stopPropagation($event)" (menuOpened)="isMenuOpen = true" (menuClosed)="isMenuOpen = false" class="!w-8 !h-8">
      <mat-icon [svgIcon]="'tabler_outline:dots-vertical'" class="icon-size-5"></mat-icon>
    </button>
    
    <mat-menu #docMenu="matMenu">
      <a mat-menu-item [routerLink]="['/konto/dokumenty', getDocumentId(), 'podglad']">
        <mat-icon [svgIcon]="'tabler_outline:eye'"></mat-icon>
        <span>Podgląd</span>
      </a>
      <a *ngIf="canEdit()" mat-menu-item [routerLink]="['/konto/dokumenty', getDocumentId()]">
        <mat-icon [svgIcon]="'tabler_outline:edit'"></mat-icon>
        <span>Edytuj</span>
      </a>
      <!-- Pobierz XML dla faktur z KSeF lub wysłanych do KSeF -->
      <button *ngIf="canDownloadXml()" mat-menu-item (click)="onDownloadXml($event)">
        <mat-icon [svgIcon]="'tabler_outline:file-code'"></mat-icon>
        <span>Pobierz XML</span>
      </button>
      <!-- Pobierz PDF dla lokalnych faktur -->
      <button *ngIf="canDownloadPdf()" mat-menu-item (click)="onDownloadPdf($event)">
        <mat-icon [svgIcon]="'tabler_outline:download'"></mat-icon>
        <span>Pobierz PDF</span>
      </button>
      <!-- Pobierz UPO dla faktur wysłanych do KSeF -->
      <button *ngIf="canDownloadUpo()" mat-menu-item (click)="onDownloadUpo($event)">
        <mat-icon [svgIcon]="'tabler_outline:certificate'"></mat-icon>
        <span>Pobierz UPO</span>
      </button>
      <!-- Oznacz jako wystawiony dla szkiców -->
      <button *ngIf="canMarkAsIssued()" mat-menu-item (click)="onMarkAsIssued($event)">
        <mat-icon [svgIcon]="'tabler_outline:file-check'"></mat-icon>
        <span>Oznacz jako wystawiony</span>
      </button>
      <!-- Wyślij do KSeF tylko dla wystawionych dokumentów (nie szkiców) -->
      <button *ngIf="enableKsefFeatures && canSendToKsef() && !canMarkAsIssued() && !isSendingToKsef" mat-menu-item (click)="onSendToKsef($event)">
        <mat-icon [svgIcon]="'ksef:ksef-logo'"></mat-icon>
        <span>Wyślij do KSeF</span>
      </button>
      <!-- Wystaw i wyślij do KSeF dla szkiców -->
      <button *ngIf="enableKsefFeatures && canSendToKsef() && canMarkAsIssued() && !isSendingToKsef" mat-menu-item (click)="onIssueAndSendToKsef($event)">
        <mat-icon [svgIcon]="'ksef:ksef-logo'"></mat-icon>
        <span>Wystaw i wyślij do KSeF</span>
      </button>
      <!-- Stan wysyłki do KSeF (zablokowany przycisk z loaderem) -->
      <button *ngIf="enableKsefFeatures && isSendingToKsef" mat-menu-item disabled>
        <mat-spinner diameter="18" class="mr-2"></mat-spinner>
        <span>Wysyłanie...</span>
      </button>
      
      <!-- Wystaw fakturę zaliczkową (tylko dla zamówień) -->
      <button *ngIf="canCreateAdvanceInvoice()" mat-menu-item (click)="onCreateAdvanceInvoice($event)">
        <mat-icon [svgIcon]="'tabler_outline:receipt-2'"></mat-icon>
        <span>Wystaw fakturę zaliczkową</span>
      </button>
      
      <!-- Akcje płatności -->
      <mat-divider *ngIf="canMarkAsPaid() || canMarkAsUnpaid()"></mat-divider>
      <button *ngIf="canMarkAsPaid()" mat-menu-item (click)="onMarkAsPaid($event)">
        <mat-icon [svgIcon]="'tabler_outline:circle-check'"></mat-icon>
        <span>Oznacz jako zapłacone</span>
      </button>
      <button *ngIf="canMarkAsUnpaid()" mat-menu-item class="!text-red-600" (click)="onMarkAsUnpaid($event)">
        <mat-icon [svgIcon]="'tabler_outline:circle-x'" class="!text-red-600"></mat-icon>
        <span>Oznacz jako do zapłaty</span>
      </button>
      
      <mat-divider *ngIf="canDelete()"></mat-divider>
      <button *ngIf="canDelete()" mat-menu-item class="!text-red-600" (click)="onDelete($event)">
        <mat-icon [svgIcon]="'tabler_outline:trash'" class="!text-red-600"></mat-icon>
        <span>Usuń</span>
      </button>
    </mat-menu>
  </div>
  
</a>

<!-- Mobile view (hidden - replaced by responsive grid) -->
<a [routerLink]="['/konto/dokumenty', getDocumentId(), 'podglad']"
   class="hidden">
  
  <!-- Direction icon -->
  <div class="flex-shrink-0 w-10 h-10 rounded-lg flex items-center justify-center"
       [ngClass]="getDirectionBadge().bgClass"
       [matTooltip]="getDirectionBadge().text">
    <mat-icon 
      class="icon-size-5"
      [ngClass]="getDirectionBadge().iconClass"
      [svgIcon]="getDirectionBadge().icon">
    </mat-icon>
  </div>
  
  <!-- Info -->
  <div class="flex-1 min-w-0">
    <div class="flex items-center gap-2">
      <span class="font-medium truncate">{{ getDocumentName() }}</span>
      <!-- Ikona KSeF dla dokumentów z KSeF -->
      <div 
        *ngIf="document.source === 'ksef'"
        class="flex-shrink-0 px-1.5 py-0.5 rounded bg-blue-100 dark:bg-blue-900/40 flex items-center justify-center"
        matTooltip="Faktura pochodzi z KSeF - nie została wygenerowana w tym programie">
        <mat-icon 
          class="!w-3.5 !h-3.5 text-blue-600 dark:text-blue-400"
          [svgIcon]="'ksef:ksef-logo'">
        </mat-icon>
      </div>
      <!-- Badge dla lokalnych dokumentów -->
      <span 
        *ngIf="document.source !== 'ksef'"
        class="flex-shrink-0 px-1.5 py-0.5 text-[10px] rounded font-medium"
        [ngClass]="getSourceBadge().class">
        {{ getSourceBadge().text }}
      </span>
    </div>
    <div class="text-sm text-gray-500 truncate">{{ getContractorName() }}</div>
  </div>
  
  <!-- Amount + date -->
  <div class="text-right flex-shrink-0">
    <div class="font-semibold">{{ getGrossAmount() | number:'1.2-2' }} {{ getCurrency() }}</div>
    <div class="text-xs text-gray-500"><date-formatter [date]="getIssueDate()"></date-formatter></div>
  </div>
  
  <!-- KSeF status -->
  <div class="flex-shrink-0 ml-1">
    <mat-icon 
      class="icon-size-5"
      [ngClass]="getKsefStatusColor()"
      [class.animate-spin]="getKsefStatus().status === 'sending'"
      [svgIcon]="getKsefStatusIcon()">
    </mat-icon>
  </div>
  
</a>
